export default __webpack_public_path__ + "static/media/bg-banner.f3058b38.jpg";